import ReactDOM from "react-dom";
import './index.css'
import React from "react";
import MainApp from "./App";

ReactDOM.render(
    <MainApp/>, document.getElementById('root')
)